if (!customElements.get("easter-eggs")) {
  customElements.define(
    "easter-eggs",
    class extends HTMLElement {
      constructor() {
        super();

        this.popup = this.querySelector("[data-popop-wrapper]");
        this.formSlot = document.querySelector("#easter-egg-form-slot");
        this.eggs = this.querySelectorAll(".easter-egg");
        this.closeButton = this.querySelector(".easter-egg__form-close");
        this.eggs.forEach((egg) => {
          const eggId = egg.getAttribute("data-egg-id");
          egg.addEventListener("click", this.showForm.bind(this, egg));
        });
        this.formSlot.addEventListener("click", (e) => {
          e.stopPropagation();
        });
        this.popup.addEventListener("click", this.closeForm.bind(this));
        this.closeButton.addEventListener("click", this.closeForm.bind(this));
      }
      closeForm() {
        this.formSlot.innerHTML = null;
        this.popup.classList.remove("active");
      }
      showForm(egg) {
        this.popup.classList.add("active");
        // this.formSlot.setAttribute("egg-id", this.eggId);
        const eggId = egg.getAttribute("data-egg-id");
        
        console.log("eggId", eggId);
         

          fetch("/?section_id=easter-eggs")
            .then((response) => response.text())
            .then((responseText) => {
              let dom = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              console.log("dom", dom);
              let formsEl = dom.querySelector(`.easter-egg__forms[data-egg-id=${eggId}]`);
              const weightStr = formsEl.dataset.weight;
              let target;
              if (this.checkCookie(eggId)) {
                this.formSlot.innerHTML = `
                <div class="egg-claimed-message-wrapper">
                <div class="egg-claimed-message easter-egg-text-style">
                You have already claimed this egg!
                </div>
                </div>
                `;
                target = parseInt(this.getCookie(eggId));
              }else{

                target = this.selectWithWeight(weightStr);
              }
              console.log("weightStr", weightStr,"formsEl", formsEl,"target", target, formsEl.querySelectorAll(`.easter-egg__form`));
              let form = formsEl.querySelectorAll(`.easter-egg__form`)[target];
              this.formSlot.prepend(form)
              // this.formSlot.appendChild(form);
              // 将该 egg id 添加到 cookie 中，在本日 24时过期，动态计算差值
              this.setCookie(eggId,target);
            });
        
      }
      selectWithWeight(weightsStr){
        const weights = weightsStr.split("|").map(weight=>parseInt(weight));
        const totalWeight = weights.reduce((weight,total)=>total+weight, 0);
        const weightPoints = [];
        for(let i = 0, total=0;i<weights.length;i++){
          total = total + weights[i];
          weightPoints.push(total);
        }
        console.log("weights", weights, "weightPoints", weightPoints);
        const result = Date.now() % totalWeight;
        for(let weightPoint of weightPoints) {
          if(weightPoints.indexOf(weightPoint) == weightPoints.length){
            console.log(weightPoints.indexOf(weightPoint), weightPoints.length);
            return weightPoints.indexOf(weightPoint);
          }
          if(result < weightPoint) {
            return weightPoints.indexOf(weightPoint);
          }
        }
      }
      setCookie(eggId, target) {
        let date = new Date();
        date.setHours(23, 59, 59, 59);
        
        document.cookie = `${eggId}=${target}; expires=${date.toUTCString()}; path=/`;
      }
      checkCookie(eggId) {
        let cookie = document.cookie;
        return cookie.includes(`${eggId}=`);
      }
      getCookie(n) {
        let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
        return a ? a[1] : '';
    }
    }
  );
}
